import { render, staticRenderFns } from "./LeadDialog.vue?vue&type=template&id=4b55d681&"
import script from "./LeadDialog.vue?vue&type=script&lang=js&"
export * from "./LeadDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports